import {QueryCache, QueryClient, type Query} from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import type {User as FirebaseUser} from 'firebase/auth';
import {isAbortError} from '../lib/abortError.ts';
import {isRefusedByBackend} from '../lib/apiErrors.ts';

declare module '@tanstack/react-query' {
    interface Register {
        queryMeta: { reportErrorsToSentry?: boolean };
    }
}

export function reportQueryErrorToSentry(error: unknown, query: Query<unknown, unknown, unknown>): void {
    if (query.meta?.reportErrorsToSentry === true && !isAbortError(error) && !isRefusedByBackend(error)) {
        Sentry.captureException(error);
    }
}

export const queryClient = new QueryClient({
    queryCache: new QueryCache({onError: reportQueryErrorToSentry}),
    defaultOptions: {
        queries: {
            retry: false,
        },
        mutations: {
            networkMode: 'always',
        },
    },
});

export function clearQueryCache(): void {
    queryClient.clear();
}

export function clearQueryCacheOnSignOut(user: FirebaseUser | null): void {
    if (!user) {
        clearQueryCache();
    }
}
